import PropTypes from 'prop-types';
import {Dialog, makeStyles, Button, DialogContent } from '@material-ui/core';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
const useStyles = makeStyles(() => ({
  root: {},
  paper: {
    borderRadius: '10px !important'
  },
  btn: {
    width: '344px',
    height: 37,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 14,
    '&:hover': {
        background: '#0f9fef',
        color: '#fff',
    },
  },
  successTxt:{
    color: '#212D40',
    textAlign: 'center',
    fontSize: '64px',
    fontFamily: 'Spartan-bold',
    textTransform: 'uppercase',
    margin: '0 0 25px',
  },
  successModalClass:{
    padding: "30px 45px 35px",
    "& p":{
      color: '#707070',
      textAlign: 'center',
      fontSize: '18px',
      lineHeight: '1.4',
      margin: '0 0 25px',
    }
  }
  
}));


successModal.propTypes = {
  openCloseSuccessModal: PropTypes.func,
  successModal: PropTypes.bool.isRequired,
  message: PropTypes.any,
};



successModal.defaultProps = {
  onClose: () => {
  }
};


function successModal({successModal, openCloseSuccessModal,message }: any) {
  const classes = useStyles();

  // close modal
  const closeModal = () => {
    openCloseSuccessModal('')
  };

  return (
    <Dialog
      disableEscapeKeyDown
      fullWidth={true}
      maxWidth={'md'}
      scroll='paper'
      open={successModal}
      style={{maxWidth:"820px", width: "100%", margin: "0 auto"}}
      classes={{
        root: classes.root,
        paper: classes.paper
      }}
    >
      <DialogContent className="customCardDesign ">
        <div style={{textAlign:'center'}} className={classes.successModalClass}>
          <CheckCircleRoundedIcon color="primary" style={{fontSize:120, marginBottom: "15px"}}></CheckCircleRoundedIcon>
          
          <h2 className={classes.successTxt}>SUCCESS!</h2>
          {(message==='buy') && 
            <>
            <p>You’re all set for a year of neuroscience at your fingertips!</p>
            <p>There’s no limits on what you can measure,<br/> so let your curiosity run wild.</p>
            </>
          }
          {(message==='upgrade') && 
            <>
            <p>You’ve upgraded your account and are ready to go with additional features!</p>
            <p>If our team can help you get to know how to make the most of these upgrades,<br/> please don’t hesitate to reach out to us.</p>
            </>
          }
          {(message==='memberAdd') && 
            <>
            <p>You’ve added licenses for your team.</p>
            <p>If we can help out your new (or existing) users in any way, <br/>please reach out to our team!</p>
            </>
          }
          <Button  color='primary' className={classes.btn} onClick={closeModal}>
            Let’s Go
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default successModal;
